<template>
    <div>
        <div class="checkPayment" @click="emitRadioValue()">
            <div class="checkInnerCircleBorder" :class="[selectedRadioValue === radioValue ? 'checkInnerCircleBorder__active':'']">
                <div class="checkInnerCircle" :class="[selectedRadioValue === radioValue ? 'checkInnerCircle__active':'']">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['radioValue', 'selectedRadioValue'],
        methods: {
            emitRadioValue() {
                this.$emit('emitRadioValue');
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../scss/variable";
.checkPayment {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.checkInnerCircle {
  margin: 3px;
  height: 12px;
  width: 12px;
  background: transparent;
  border: none;
  border-radius: 50%;
}

.checkInnerCircle__active {
  background: $theme-text-color;
}


.checkInnerCircleBorder {
  border: 1px solid $placeholder-color;
  display: inline-block;
  border-radius: 50%;
}

.checkInnerCircleBorder__active {
  border: 1px solid #6767e7;
}
</style>